module.exports = __webpack_public_path__ + "static/logo-outer-shadow-3ff381a790fb875b5ab88b75df8bb6cd.png";